import { GetServerSidePropsContext } from "next";

/** The origin that ApolloClient should be pointed to for its links.
 * ---
 * Origins need to be absolute URLs in the server environment but can be
 * relative URLs in the browser. Defaulting to relative URLs helps reduce the
 * need for CORS requests and configurations.
 */
const getApolloClientOrigin = (context?: GetServerSidePropsContext) => {
  const isVercel = Boolean(process.env.NEXT_PUBLIC_VERCEL_ENV);

  // If we're local, then just use localhost:8000
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === "development" && !isVercel) {
    return "http://localhost:8080";
  }

  // If we're in vercel, in SSR mode, use the req to determine which host we're on.
  // Vercel has various deployment urls, like `reporting-git-BRANCHNAME`, or `reporting.vercel`.
  // We can't piece it together, just get it from the req and move along
  if (typeof window === "undefined" && context) {
    return `https://${context.req.headers.host}`;
  }

  // In client side rendered mode (in the browser) we can use relative urls
  if (typeof window !== "undefined") {
    return "";
  }

  // Only set an origin for server side
  return process.env.NEXT_PUBLIC_ZAPIER_ORIGIN;
};

export default getApolloClientOrigin;
